/* eslint-disable no-bitwise, no-cond-assign */
// HTML DOM and SVG DOM may have different support levels,
// so we need to check on context instead of a document root element.
export default function contains(context, node) {
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/contains.js
// module id = 278
// module chunks = 0